import {useEffect} from 'react'
import {TextField, Autocomplete, CircularProgress, Typography} from '@mui/material'
import {LocationOn} from '@mui/icons-material'
import {Controller, useWatch} from 'react-hook-form'
import {useAddressAutocomplete} from '../../hooks'

export default ({control, name, error, helperText, placeholder = 'Start typing a Minnesota address...', onSelect}) => {
    const {options, addressLoading, search} = useAddressAutocomplete()
    const streetValue = useWatch({control, name})

    useEffect(() => {
        const timeout = setTimeout(() => {
            search(streetValue)
        }, 1000)
        return () => clearTimeout(timeout)
    }, [streetValue])

    return (
        <Controller
            name={name}
            control={control}
            render={({field}) => (
                <Autocomplete
                    freeSolo
                    filterOptions={x => x}
                    options={options}
                    getOptionLabel={opt => (typeof opt === 'string' ? opt : opt.properties?.address_line1 || '')}
                    inputValue={field.value || ''}
                    onInputChange={(_, val, reason) => {
                        if (reason === 'input' || reason === 'clear') {
                            field.onChange(val)
                        }
                    }}
                    onChange={(_, selected) => {
                        if (!selected || typeof selected === 'string') return
                        field.onChange([selected?.housenumber, selected?.street].filter(Boolean).join(' '))
                        onSelect?.(selected)
                    }}
                    loading={addressLoading}
                    noOptionsText="No addresses found"
                    renderOption={(props, option) => (
                        <li {...props} key={option?.place_id}>
                            <div style={{display: 'flex', alignItems: 'start', gap: 6}}>
                                <LocationOn sx={{mt: 0.3, color: 'text.secondary', fontSize: 22, flexShrink: 0}} />
                                <div>
                                    <Typography variant="body2" fontWeight={500}>
                                        {[option?.housenumber, option?.street].filter(Boolean).join(' ')}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {[option?.city || option?.town, option?.state, option?.postcode].filter(Boolean).join(', ')}
                                    </Typography>
                                </div>
                            </div>
                        </li>
                    )}
                    renderInput={params => (
                        <TextField
                            {...params}
                            placeholder={placeholder}
                            fullWidth
                            error={error}
                            helperText={helperText}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {addressLoading && <CircularProgress size={16} />}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            }}
                        />
                    )}
                />
            )}
        />
    )
}
